

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';


// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

// Material components
import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';

import DistributionConsolidated from './DistributionConsolidated';
import DistributionIsps from './DistributionIsps';
import DistributionError from './DistributionAvailability'

// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class Distribution extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        //console.log('render dc')
        return(
            <PerfectScrollbar>
                <Grid
                container
                spacing={1}
                >
                    <DistributionConsolidated data={this.props.data} />
                    <DistributionIsps data={this.props.data} />
                    <DistributionError data={this.props.data} />
                </Grid>
            </PerfectScrollbar>
        )
    }
}



export default
    compose(withRouter, withStyles(styles))(Distribution);